import c2cListingService from "../../../service/c2c-listing-service";

export const getC2cListingData = ({ appId, secureToken }) => () => {
    return new Promise((resolve, reject) => {
        c2cListingService
            .getListingDataViaAppId({ appId, secureToken })
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const initiateListing = (data, secureToken) => () => {
    return new Promise((resolve, reject) => {
        c2cListingService.initiateListing(data, secureToken).then((response) => {
            resolve(response.data.data);
        }).catch((error) => {
            reject(error);
        });
    });
};
